
export default {
    name: "ULIP",
    meta: {
        icon: "dashboard",
        expanded: true,
        auth: true
    },
    departmentName: "ULIP",
    finalPagePermision: "",
    children: [

        {
            name: "ULIP PCS01",
            path: "/ulip/PCS01",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/PCS01_ResponseDisplay.vue"),
            finalPagePermision: "PCS01",
            // finalPagePermision: "",
        },
        {
            name: "ULIP PCS02",
            path: "/ulip/PCS02",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/PCS02_ResponseDisplay.vue"),
            finalPagePermision: "PCS02",
            // finalPagePermision: "",
        },
         {
            name: "ULIP PCS03",
            path: "/ulip/PCS03",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/PCS03_ResponseDisplay.vue"),
            finalPagePermision: "PCS03",
            // finalPagePermision: "",
        },
        {
            name: "ULIP PCS04",
            path: "/ulip/PCS04",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/PCS04_ResponseDisplay.vue"),
            finalPagePermision: "PCS04",
            // finalPagePermision: "",
        },
        {
            name: "ULIP PCS05",
            path: "/ulip/PCS05",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/PCS05_ResponseDisplay.vue"),
            finalPagePermision: "PCS05",
            // finalPagePermision: "",
        },
       

        {
            name: "ULIP PCS06",
            path: "/ulip/PCS06",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/PCS06_ResponseDisplay.vue"),
            finalPagePermision: "PCS06",
            // finalPagePermision: "",
        },
        {
            name: "ULIP FASTTAG",
            path: "/ulip/FASTTAG",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/FASTAG_ResponseDisplay.vue"),
            finalPagePermision: "FASTTAG",
            // finalPagePermision: "",
        },
        {
            name: "ULIP SARATHI",
            path: "/ulip/SARATHI",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/SARATHI_ResponseDisplay.vue"),
            // finalPagePermision: "SARATHI",
            finalPagePermision: "",
        },
        {
            name: "ULIP VAHAN01",
            path: "/ulip/VAHAN01",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/VAHAN01_ResponseDisplay.vue"),
            // finalPagePermision: "",
            finalPagePermision: "VAHAN01",
        },
        {
            name: "ULIP VAHAN02",
            path: "/ulip/VAHAN02",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/VAHAN02_ResponseDisplay.vue"),
            // finalPagePermision: "",
            finalPagePermision: "VAHAN02",
        },
        {
            name: "ULIP VAHAN03",
            path: "/ulip/VAHAN03",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/VAHAN03_ResponseDisplay.vue"),
            // finalPagePermision: "",
            finalPagePermision: "VAHAN03",
        },
         {
            name: "ULIP ECHALLAN01",
            path: "/ulip/ECHALLAN01",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03','ULIP ECHALLAN01'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/ECHALLAN_ResponseDisplay.vue"),
            // finalPagePermision: "",
            finalPagePermision: "ECHALLAN01",
        },
           {
            name: "ULIP ICEGATE05",
            path: "/ulip/ICEGATE05",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03','ULIP ECHALLAN01'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/ICEGATE05_ResponseDisplay.vue"),
            // finalPagePermision: "",
            finalPagePermision: "ICEGATE05",
        },
           {
            name: "ULIP ICEGATE06",
            path: "/ulip/ICEGATE06",
            permissionName: 'ULIP',
            keywords: ['ULIP PCS01', 'ULIP PCS02', 'ULIP PCS03', 'ULIP PCS04','ULIP PCS05','ULIP PCS06','ULIP FASTTAG','ULIP SARATHI','ULIP VAHAN01','ULIP VAHAN02','ULIP VAHAN03','ULIP ECHALLAN01'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/ICEGATE06_ResponseDisplay.vue"),
            // finalPagePermision: "",
            finalPagePermision: "ICEGATE06",
        },

    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/ulipDashboard.js